import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useGlobalContext } from './GlobalContext';

export const STATUS_PRIORITY = {
    new: 2,
    promo: 1,
};

export const FGHProviderItems = [
    {
        id: 25,
        provider_name: 'HACKSAW',
        provider_logo: '/images/providers/logo/hacksaw-gaming.webp',
        provider_logo_dark: '/images/providers/dark/hacksaw-gaming-black.webp',
        provider_status: 'New',
        provider_message: 'Best Hacksaw Gaming Games',
    },
    {
        id: 1,
        provider_name: 'PP',
        provider_logo: '/images/providers/logo/pragmatic-play.webp',
        provider_logo_dark: '/images/providers/dark/pragmatic-play-black.webp',
        provider_status: 'Promo',
        provider_message: 'Best Pragmatic Play Games',
    },
    {
        id: 3,
        provider_name: 'PGSOFT',
        provider_logo: '/images/providers/logo/pgsoft.webp',
        provider_logo_dark: '/images/providers/dark/pgsoft-black.webp',
        provider_status: 'Promo',
        provider_message: 'Best PGSOFT Games',
    },
    {
        id: 6,
        provider_name: 'BNG',
        provider_logo: '/images/providers/logo/bng.webp',
        provider_logo_dark: '/images/providers/logo/bng.webp',
        provider_status: 'Promo',
        provider_message: 'Best BNG Games',
    },
    {
        id: 26,
        provider_name: 'FASTSPIN',
        provider_logo: '/images/providers/logo/fastspin.webp',
        provider_logo_dark: '/images/providers/dark/fastspin-black.webp',
        provider_status: 'Promo',
        provider_message: 'Best Fastspin Games',
    },
    {
        id: 27,
        provider_name: 'VP',
        provider_logo: '/images/providers/logo/vertexplay.webp',
        provider_logo_dark: '/images/providers/dark/vertexplay-black.webp',
        provider_status: 'Promo',
        provider_message: 'Best Vertex Play Games',
    },

    {
        id: 14,
        provider_name: 'JDB',
        provider_logo: '/images/providers/logo/jdb.webp',
        provider_logo_dark: '/images/providers/logo/jdb.webp',
        provider_status: '',
        provider_message: 'Best JDB Games',
    },
    {
        id: 28,
        provider_name: 'VPLUS',
        provider_logo: '/images/providers/logo/vplus.webp',
        provider_logo_dark: '/images/providers/dark/vplus-dark.webp',
        provider_status: '',
        provider_message: 'Best VPlus Play Games',
    },
    {
        id: 2,
        provider_name: 'CQ9',
        provider_logo: '/images/providers/logo/cq9.webp',
        provider_logo_dark: '/images/providers/logo/cq9.webp',
        provider_status: '',
        provider_message: 'Best of CQ9',
    },

    {
        id: 13,
        provider_name: 'TPG',
        provider_logo: '/images/providers/logo/tpg.webp',
        provider_logo_dark: '/images/providers/dark/tpg-black.webp',
        provider_status: '',
        provider_message: 'Best TPG Games',
    },

    // {
    //   id: 24,
    //   provider_name: "PLAYTECH",
    //   provider_logo: "/images/providers/logo/playtech.webp",
    //   provider_logo_dark: "/images/providers/dark/playtech-black.webp",
    //   provider_status: "",
    //   provider_message: "Best Playtech Games",
    // },

    {
        id: 19,
        provider_name: 'HABANERO',
        provider_logo: '/images/providers/logo/habanero.webp',
        provider_logo_dark: '/images/providers/dark/habanero-black.webp',
        provider_status: '',
        provider_message: 'Best Habanero Games',
    },

    // {
    // 	id: 20,
    // 	provider_name: "WAZDAN",
    // 	provider_logo: "/images/providers/logo/wazdan.webp",
    // 	provider_logo_dark: "/images/providers/dark/wazdan-black.webp",
    // 	provider_status: "",
    // 	provider_message: "Best Wazdan Games",
    // },

    {
        id: 22,
        provider_name: 'ELBET',
        provider_logo: '/images/providers/logo/elbet.webp',
        provider_logo_dark: '/images/providers/dark/elbet-black.webp',
        provider_status: '',
        provider_message: 'Best Bigpot Games',
    },
    {
        id: 21,
        provider_name: 'BIGPOT',
        provider_logo: '/images/providers/logo/bigpot-gaming.webp',
        provider_logo_dark: '/images/providers/dark/bigpot-gaming-black.webp',
        provider_status: '',
        provider_message: 'Best Bigpot Games',
    },

    {
        id: 25,
        provider_name: 'YELLOWBAT',
        provider_logo: '/images/providers/logo/yellow-bat.webp',
        provider_logo_dark: '/images/providers/logo/yellow-bat.webp',
        provider_status: '',
        provider_message: 'Best Yellowbat Games',
    },
    // {
    //   id: 15,
    //   provider_name: "JOLLIPLAY",
    //   provider_logo: "/images/providers/logo/jolliplay.webp",
    //   provider_logo_dark: "/images/providers/logo/jolliplay.webp",
    //   provider_status: "",
    //   provider_message: "Best Jolliplay Games",
    // },

    {
        id: 7,
        provider_name: 'BETSOFT',
        provider_logo: '/images/providers/logo/betsoft.webp',
        provider_logo_dark: '/images/providers/dark/betsoft-black.webp',
        provider_status: '',
        provider_message: 'Best Betsoft Games',
    },
    {
        id: 4,
        provider_name: 'NEXTSPIN',
        provider_logo: '/images/providers/logo/nextspin.webp',
        provider_logo_dark: '/images/providers/dark/nextspin-black.webp',
        provider_status: '',
        provider_message: 'Best NextSpin Games',
    },
    {
        id: 5,
        provider_name: 'RTG',
        provider_logo: '/images/providers/logo/rtg.webp',
        provider_logo_dark: '/images/providers/dark/rtg-black.webp',
        provider_status: '',
        provider_message: 'Best RTG Games',
    },

    {
        id: 8,
        provider_name: 'REDTIGER',
        provider_logo: '/images/providers/logo/red-tiger.webp',
        provider_logo_dark: '/images/providers/dark/red-tiger-black.webp',
        provider_status: '',
        provider_message: 'Best Red Tiger Games',
    },
    {
        id: 9,
        provider_name: 'POPOK',
        provider_logo: '/images/providers/logo/popok.webp',
        provider_logo_dark: '/images/providers/logo/popok.webp',
        provider_status: '',
        provider_message: 'Best POPOK Games',
    },
    {
        id: 10,
        provider_name: 'YGG',
        provider_logo: '/images/providers/logo/yggdrasil.webp',
        provider_logo_dark: '/images/providers/dark/yggdrasil-black.webp',
        provider_status: '',
        provider_message: 'Best YGG Games',
    },
    {
        id: 11,
        provider_name: 'NETENT',
        provider_logo: '/images/providers/logo/netent.webp',
        provider_logo_dark: '/images/providers/dark/netent-black.webp',
        provider_status: '',
        provider_message: 'Best Netent Games',
    },

    {
        id: 12,
        provider_name: 'DRAGONGAMING',
        provider_logo: '/images/providers/logo/dragongaming.webp',
        provider_logo_dark: '/images/providers/dark/dragongaming-black.webp',
        provider_status: '',
        provider_message: 'Best Dragon Gaming Games',
    },

    {
        id: 17,
        provider_name: 'NLC',
        provider_logo: '/images/providers/logo/nolimitcity.webp',
        provider_logo_dark: '/images/providers/dark/nolimitcity-black.webp',
        provider_status: '',
        provider_message: 'Best NLC Games',
    },
    {
        id: 18,
        provider_name: 'BTG',
        provider_logo: '/images/providers/logo/btg.webp',
        provider_logo_dark: '/images/providers/dark/btg-black.webp',
        provider_status: '',
        provider_message: 'Best BTC Games',
    },
    {
        id: 16,
        provider_name: 'FACHAI',
        provider_logo: '/images/providers/logo/fachai.webp',
        provider_logo_dark: '/images/providers/dark/fachai-black.webp',
        provider_status: '',
        provider_message: 'Best FACHAI Games',
    },
    {
        id: 23,
        provider_name: 'INBET',
        provider_logo: '/images/providers/dark/inbet-black.webp',
        provider_logo_dark: '/images/providers/logo/inbet.webp',
        provider_status: '',
        provider_message: 'Best Inbet Games',
    },

    {
        id: 11,
        provider_name: 'JILI',
        provider_logo: '/images/providers/logo/jili.webp',
        provider_logo_dark: '/images/providers/logo/jili.webp',
        provider_status: 'Promo',
        provider_message: 'Best JILI Games',
    },
    {
        id: 25,
        provider_name: 'SIMPLEPLAY',
        provider_logo: '/images/providers/logo/simpleplay.webp',
        provider_logo_dark: '/images/providers/dark/simpleplay-black.webp',
        provider_status: 'New',
        provider_message: 'Best SimplePlay Games',
    },
];

const ProvidersData = () => {
    const { gamesCountByProvider, loading } = useGlobalContext();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // open & close modal
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    // close modal on ESC
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
        };
        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, []);

    // Calculate the starting index: the second-to-last slide
    const initialSlideIndex =
        FGHProviderItems.length > 1 ? FGHProviderItems.length - 2 : 0;

    const initialSlideIndexMobile =
        FGHProviderItems.length > 1 ? FGHProviderItems.length - 1 : 0;

    // Slick slider settings with dynamic initialSlide
    const settings = {
        dots: false,
        infinite: true,
        speed: 1200,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: 'ease-in-out',
        draggable: true,
        arrows: true,
        pauseOnHover: true,
        initialSlide: initialSlideIndex,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    speed: 1,
                    autoplay: false,
                    initialSlide: initialSlideIndexMobile,
                    draggable: true,
                    swipe: true,
                    arrows: false,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    waitForAnimate: false,
                },
            },
            {
                breakpoint: 1325,
                settings: {
                    slidesToShow: 3,
                    speed: 1,
                    autoplay: false,
                    initialSlide: initialSlideIndexMobile,
                    draggable: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    waitForAnimate: false,
                },
            },
            {
                breakpoint: 1326,
                settings: {
                    slidesToShow: 4,
                    speed: 1,
                    autoplay: false,
                    initialSlide: initialSlideIndexMobile,
                    draggable: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    waitForAnimate: false,
                },
            },
            {
                breakpoint: 1625,
                settings: {
                    slidesToShow: 4,
                    speed: 1,
                    autoplay: false,
                    initialSlide: initialSlideIndexMobile,
                    draggable: true,
                    swipe: true,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    waitForAnimate: false,
                },
            },
        ],
    };

    // Helper function to return a style object based on status
    const getStatusStyle = (status) => {
        switch (status) {
            case 'Promo':
                return { backgroundColor: 'rgba(255, 81, 0, 0.932)' };
            case 'New':
                return { backgroundColor: 'red' };
            case 'Event':
                return { backgroundColor: 'green' };
            default:
                return {};
        }
    };

    const [isLightMode, setIsLightMode] = useState(() => {
        try {
            const saved = localStorage.getItem('theme');
            if (saved === 'light') return true;
            if (saved === 'dark') return false;
            return window.matchMedia(
                '(prefers-colorjuvenile meaning-scheme: light)'
            ).matches;
        } catch {
            return false;
        }
    });

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const currentTheme = document.documentElement.dataset.theme;
            setIsLightMode(currentTheme === 'light');
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="fgh-providers-section">
            <div className="fgh-headlines-controls">
                <div className="fgh-headline-text">
                    <h2 className="fgh-h2-style">
                        Top Providers, Recommended for You
                    </h2>
                </div>
                <button className="fgh-view-all-btn" onClick={openModal}>
                    View All
                </button>
            </div>
            <Slider {...settings}>
                {FGHProviderItems.map((providerItem) => (
                    <div key={providerItem.id}>
                        <a
                            href={`/slots/?provider=${encodeURIComponent(
                                providerItem.provider_name
                            )}`}
                            className="fgh-provider-link"
                        >
                            <div className="fgh-provider-items">
                                {providerItem.provider_status && (
                                    <span
                                        className="fgh-provider-status-label"
                                        style={getStatusStyle(
                                            providerItem.provider_status
                                        )}
                                    >
                                        {providerItem.provider_status}
                                    </span>
                                )}
                                <img
                                    src={
                                        !isLightMode &&
                                        providerItem.provider_logo
                                            ? providerItem.provider_logo
                                            : providerItem.provider_logo_dark
                                    }
                                    alt={providerItem.provider_name}
                                    className="fgh-provider-logo"
                                />
                                {loading ? (
                                    <span className="fgh-provider-total-games-count">
                                        ... Games
                                    </span>
                                ) : (
                                    <span className="fgh-provider-total-games-count">
                                        {
                                            gamesCountByProvider[
                                                providerItem.provider_name
                                            ]
                                        }{' '}
                                        {gamesCountByProvider[
                                            providerItem.provider_name
                                        ] === 1
                                            ? 'Game'
                                            : 'Games'}
                                    </span>
                                )}
                            </div>
                        </a>
                    </div>
                ))}
            </Slider>
            {isModalOpen &&
                createPortal(
                    <div className="modal-portal">
                        <div className="fgh-modal-overlay" onClick={closeModal}>
                            <div
                                className="fgh-modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="fgh-providers-grid">
                                    {[...FGHProviderItems]
                                        .sort((a, b) => {
                                            const aPriority =
                                                STATUS_PRIORITY[
                                                    a.provider_status?.toLowerCase()
                                                ] ?? 0;
                                            const bPriority =
                                                STATUS_PRIORITY[
                                                    b.provider_status?.toLowerCase()
                                                ] ?? 0;

                                            // Higher priority first
                                            return bPriority - aPriority;
                                        })

                                        .map((providerItem) => (
                                            <a
                                                key={providerItem.id}
                                                href={`/slots/?provider=${encodeURIComponent(
                                                    providerItem.provider_name
                                                )}`}
                                                className="fgh-provider-link"
                                            >
                                                <div className="fgh-provider-items-popup">
                                                    {providerItem.provider_status && (
                                                        <span
                                                            className="fgh-provider-status-label"
                                                            style={getStatusStyle(
                                                                providerItem.provider_status
                                                            )}
                                                        >
                                                            {
                                                                providerItem.provider_status
                                                            }
                                                        </span>
                                                    )}
                                                    <img
                                                        src={
                                                            !isLightMode &&
                                                            providerItem.provider_logo
                                                                ? providerItem.provider_logo
                                                                : providerItem.provider_logo_dark
                                                        }
                                                        onError={(e) => {
                                                            e.currentTarget.onerror =
                                                                null;
                                                            e.currentTarget.src =
                                                                providerItem.provider_logo ||
                                                                '/images/providers/logo-fallback.webp';
                                                        }}
                                                        alt={
                                                            providerItem.provider_name
                                                        }
                                                        className="fgh-provider-logo-pop"
                                                    />

                                                    <span className="fgh-provider-total-games-count">
                                                        {
                                                            gamesCountByProvider[
                                                                providerItem
                                                                    .provider_name
                                                            ]
                                                        }{' '}
                                                        {gamesCountByProvider[
                                                            providerItem
                                                                .provider_name
                                                        ] === 1
                                                            ? 'Game'
                                                            : 'Games'}
                                                    </span>
                                                </div>
                                            </a>
                                        ))}
                                </div>
                            </div>
                            <div>
                                <button
                                    className="fgh-modal-close"
                                    onClick={closeModal}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>,
                    document.body
                )}
            {/* {isModalOpen && (
        <div className="fgh-modal-overlay" onClick={closeModal}>
          <div
            className="fgh-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="fgh-providers-grid">
              {[...FGHProviderItems]
                .sort((a, b) => {
                  const aPriority =
                    STATUS_PRIORITY[a.provider_status?.toLowerCase()] ?? 0
                  const bPriority =
                    STATUS_PRIORITY[b.provider_status?.toLowerCase()] ?? 0

                  // Higher priority first
                  return bPriority - aPriority
                })

                .map((providerItem) => (
                  <a
                    key={providerItem.id}
                    href={`/slots/?provider=${encodeURIComponent(
                      providerItem.provider_name
                    )}`}
                    className="fgh-provider-link"
                  >
                    <div className="fgh-provider-items-popup">
                      {providerItem.provider_status && (
                        <span
                          className="fgh-provider-status-label"
                          style={getStatusStyle(providerItem.provider_status)}
                        >
                          {providerItem.provider_status}
                        </span>
                      )}
                      <img
                        src={
                          !isLightMode && providerItem.provider_logo
                            ? providerItem.provider_logo
                            : providerItem.provider_logo_dark
                        }
                        onError={(e) => {
                          e.currentTarget.onerror = null
                          e.currentTarget.src =
                            providerItem.provider_logo ||
                            "/images/providers/logo-fallback.webp"
                        }}
                        alt={providerItem.provider_name}
                        className="fgh-provider-logo-pop"
                      />

                      <span className="fgh-provider-total-games-count">
                        {gamesCountByProvider[providerItem.provider_name]}{" "}
                        {gamesCountByProvider[providerItem.provider_name] === 1
                          ? "Game"
                          : "Games"}
                      </span>
                    </div>
                  </a>
                ))}
            </div>
          </div>
          <div>
            <button className="fgh-modal-close" onClick={closeModal}>
              Close
            </button>
          </div>
        </div>
      )} */}
        </div>
    );
};

export default ProvidersData;
